/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestMapleV2PoolManager extends Contract<ITestMapleV2PoolManager> {
  factory: Call<() => string, ITestMapleV2PoolManager>
  'factory()': Call<() => string, ITestMapleV2PoolManager>
  pool: Call<() => string, ITestMapleV2PoolManager>
  'pool()': Call<() => string, ITestMapleV2PoolManager>
  poolDelegate: Call<() => string, ITestMapleV2PoolManager>
  'poolDelegate()': Call<() => string, ITestMapleV2PoolManager>
  setLiquidityCap: Send<(_liquidityCap: BigNumberish) => void, ITestMapleV2PoolManager>
  'setLiquidityCap(uint256)': Send<(_liquidityCap: BigNumberish) => void, ITestMapleV2PoolManager>
  totalAssets: Call<() => BigNumber, ITestMapleV2PoolManager>
  'totalAssets()': Call<() => BigNumber, ITestMapleV2PoolManager>
  withdrawalManager: Call<() => string, ITestMapleV2PoolManager>
  'withdrawalManager()': Call<() => string, ITestMapleV2PoolManager>
}

let ITestMapleV2PoolManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestMapleV2PoolManagerBytecode = '0x';
}

// prettier-ignore
export const ITestMapleV2PoolManager = contract<ITestMapleV2PoolManager>(ITestMapleV2PoolManagerBytecode)`
  function factory() view returns (address factory_)
  function pool() view returns (address pool_)
  function poolDelegate() view returns (address poolDelegate_)
  function setLiquidityCap(uint256 _liquidityCap)
  function totalAssets() view returns (uint256 totalAssets_)
  function withdrawalManager() view returns (address withdrawalManager_)
`;